export default "__VITE_ASSET__meJk4Fj1__"